import editIcon from '../../../assets/editIcon.png';
import trashIcon from '../../../assets/trashIcon.png';
import { CopyIcon } from '../../../components/Icons';
import toast from 'react-hot-toast';

export function AttachmentActionMenu({
  attachment,
  isEditing,
  canUpdate,
  canDelete,
  readOnly,
  onEdit,
  onDelete,
  onDownload,
  isDownloading,
  onUploadToDrive,
  isUploadingToDrive,
}) {
  return (
    <div
      className="flex items-center justify-end gap-1"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Show download for non-link types, copy for link types */}
      {attachment.attachment_type !== 'link' &&
      attachment.attachment_type !== 'external_link' ? (
        <button
          type="button"
          onClick={() => onDownload(attachment)}
          disabled={isDownloading}
          className="w-9 h-9 flex items-center justify-center rounded-[8px] text-[#868686] hover:text-[#50AB3D] hover:bg-[#50AB3D]/10 transition-colors focus:outline-none disabled:opacity-50"
          title="Download file"
          aria-label="Download file"
        >
          {isDownloading ? (
            <div className="w-4 h-4 border-2 border-[#50AB3D]/30 border-t-[#50AB3D] rounded-full animate-spin" />
          ) : (
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
          )}
        </button>
      ) : (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            if (!attachment.file_url) return;
            navigator.clipboard.writeText(attachment.file_url);
            toast.success('Link copied successfully.');
          }}
          className="w-9 h-9 flex items-center justify-center rounded-[8px] text-[#868686] hover:text-blue-500 hover:bg-blue-500/10 transition-colors focus:outline-none"
          title="Copy link"
          aria-label="Copy link"
        >
          <CopyIcon className="w-4 h-4" />
        </button>
      )}

      {/* Upload to Google Drive — only for file-type attachments */}
      {onUploadToDrive &&
        attachment.attachment_type !== 'link' &&
        attachment.attachment_type !== 'external_link' && (
          <button
            type="button"
            id={`attachment-drive-upload-${attachment.id}`}
            onClick={() => onUploadToDrive(attachment)}
            disabled={isUploadingToDrive}
            className="w-9 h-9 flex items-center justify-center rounded-[8px] hover:bg-yellow-50 transition-colors focus:outline-none disabled:opacity-50"
            title="Upload to Google Drive"
            aria-label="Upload to Google Drive"
          >
            {isUploadingToDrive ? (
              <div className="w-4 h-4 border-2 border-yellow-400/30 border-t-yellow-500 rounded-full animate-spin" />
            ) : (
              <svg viewBox="0 0 24 24" className="w-4 h-4">
                <path fill="#FBBC05" d="M7.71 3.5L1.15 15l3.43 6 6.57-11.5z" />
                <path fill="#4285F4" d="M22.85 15L16.29 3.5H9.15L15.71 15z" />
                <path fill="#34A853" d="M4.58 21h14.84l3.43-6H1.15z" />
              </svg>
            )}
          </button>
        )}

      {!readOnly && (
        <>
          {canUpdate && (
            <button
              type="button"
              onClick={() => onEdit(attachment)}
              disabled={isEditing}
              className="w-9 h-9 flex items-center justify-center rounded-[8px] hover:bg-amber-500/10 transition-colors focus:outline-none disabled:opacity-50"
              title="Edit attachment"
              aria-label="Edit attachment"
            >
              <img src={editIcon} alt="" className="w-4 h-4 object-contain" />
            </button>
          )}
          {canDelete && (
            <button
              type="button"
              onClick={() => onDelete(attachment.id)}
              className="w-9 h-9 flex items-center justify-center rounded-[8px] hover:bg-red-500/10 transition-colors focus:outline-none"
              title="Delete attachment"
              aria-label="Delete attachment"
            >
              <img src={trashIcon} alt="" className="w-4 h-4 object-contain" />
            </button>
          )}
        </>
      )}
    </div>
  );
}
